import { useEffect } from "react";

export const useAfterPayInjectionScript = (setAfterPayReady) => {
    useEffect(() => {
        // Return if AfterPaySDK is already injected.
        if(document.querySelector('#afterpay-message-script')) {
            setAfterPayReady(true);
            return;
        }

        const afterPayScriptElement = document.createElement('script');
        let srcUrlPrefix = window.location.hostname === 'localhost' ? 'http://localhost:8080' : '';
        afterPayScriptElement.src = srcUrlPrefix + '/apps/jcom/s4/src/component/afterpay-message/afterpay-message.js';
        afterPayScriptElement.setAttribute("data-ot-ignore", "data-ot-ignore");
        afterPayScriptElement.setAttribute("id", "afterpay-message-script");
        afterPayScriptElement.onload = () => {
            window.jostensAfterPay.subscribe(() => {
                setAfterPayReady && setAfterPayReady(true);
            });
        }
        document.head.appendChild(afterPayScriptElement);
    }, []);
}